import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  input,
  Input,
  OnDestroy,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { TreeScrollService } from 'shared/domain';

import { GuidelineDto } from '@treetop/shared/model';

import { ChapterWidgetComponent } from '../chapter-widget.component';

@Component({
  selector: 'tt-chapter-widget-list',
  standalone: true,
  templateUrl: './chapter-widget-list.component.html',
  styleUrls: ['./chapter-widget-list.component.scss'],
  imports: [ChapterWidgetComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChapterWidgetListComponent implements AfterViewInit, OnDestroy {
  private treeScrollService = inject(TreeScrollService);
  private elementRef = inject(ElementRef);

  public chapterIds = input<string[]>([]);

  @Input() public numbering: string;
  @Input() public parentChapterId: string | null = null;

  @Output() public guidelineChanged = new EventEmitter<GuidelineDto>();

  @ViewChildren('chapterElement') public chapterElements: QueryList<ElementRef>;

  protected resizeObserver: ResizeObserver;

  public ngAfterViewInit(): void {
    // Lazy loading during scroll
    this.resizeObserver = new ResizeObserver(() => {
      this.treeScrollService.updateScrollOnChanges();
    });

    // Initial set: <smartbook-list> is only rendered when the chapters are present.
    this.treeScrollService.updateScrollOnChanges();

    // Initialize ResizeObserver to observe this component (<guideline-template-edit>)
    const element = this.elementRef.nativeElement as HTMLElement;
    this.resizeObserver.observe(element);
  }

  public ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.elementRef.nativeElement as HTMLElement);
    }
  }
}
